import { render, staticRenderFns } from "./VxPagination.vue?vue&type=template&id=5714b878&scoped=true"
import script from "./VxPagination.vue?vue&type=script&lang=js"
export * from "./VxPagination.vue?vue&type=script&lang=js"
import style0 from "./VxPagination.vue?vue&type=style&index=0&id=5714b878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5714b878",
  null
  
)

export default component.exports